export default "__VITE_ASSET__a9eb246a__"